import React from 'react';
import Furniture from '../../components/furniture'

const FurniturePage = () => {

    return (
        <div>
            <Furniture />

        </div>
    )
}
export default FurniturePage